import {AbstractModel} from "./abstract-model";
import {User} from './user';

export class UserEvent extends AbstractModel {
  id: number | null = null;
  user: User | null = null;
  ip: string | null = null;
  country: string | null = null;
  type: string | null = null;
  method: string | null = null;
  path: string | null = null;
  statusCode: number | null = null;
  userAgent: string | null = null;
  createdAt: Date | null = null;
  action: string | null = null;
  data: any | null = null;
  key: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    return this;
  }
}
